export default "__VITE_ASSET__6b7ecdb5__"